import { jsx as f } from "react/jsx-runtime";
import { forwardRef as l } from "react";
function m(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var p = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var c;
function _() {
  return c || (c = 1, function(n) {
    (function() {
      var u = {}.hasOwnProperty;
      function e() {
        for (var r = "", t = 0; t < arguments.length; t++) {
          var o = arguments[t];
          o && (r = i(r, s.call(this, o)));
        }
        return r;
      }
      function s(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return e.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var t = "";
        for (var o in r)
          u.call(r, o) && r[o] && (t = i(t, this && this[o] || o));
        return t;
      }
      function i(r, t) {
        return t ? r ? r + " " + t : r + t : r;
      }
      n.exports ? (e.default = e, n.exports = e) : window.classNames = e;
    })();
  }(p)), p.exports;
}
var j = _();
const d = /* @__PURE__ */ m(j), x = {
  "purpur-container": "_purpur-container_2jjzm_1",
  "purpur-container--xs": "_purpur-container--xs_2jjzm_12",
  "purpur-container--sm": "_purpur-container--sm_2jjzm_23",
  "purpur-container--md": "_purpur-container--md_2jjzm_38",
  "purpur-container--lg": "_purpur-container--lg_2jjzm_41",
  "purpur-container--xl": "_purpur-container--xl_2jjzm_44",
  "purpur-container--xxl": "_purpur-container--xxl_2jjzm_47"
}, h = d.bind(x), a = "purpur-container", y = l(
  ({ children: n, className: u, width: e = "xxl", ...s }, i) => {
    const r = h([u, a, `${a}--${e}`]);
    return /* @__PURE__ */ f("div", { className: r, ref: i, ...s, children: n });
  }
);
y.displayName = "Container";
export {
  y as Container
};
//# sourceMappingURL=container.es.js.map
